import { createApp } from 'vue'
import StafetDonationStepTwo from './StafetDonationStepTwo'

const el = '.kb-component--stafet-donation-step-two'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDonationStepTwoDOM) => {
            const component = createApp(StafetDonationStepTwo).use(Store)
            component.mount(StafetDonationStepTwoDOM)
        })
    }
}
